import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import GuideImgOne from "../../../assets/images/guide_img_1.png";
import GuideImgTwo from "../../../assets/images/guide_img_2.png";
import GuideImgThree from "../../../assets/images/guide_img_3.png";
import Paragraph from "../../../components/core/typography/Paragraph";
import Button from "../../../components/core/form-components/Button";
import { languageIdSelector } from "../../../redux/slices/website/languageSlice";
import { useSelector } from "react-redux";
import { LanguageTranslation } from "../../../components/language-translation/LanguageTranslation";

interface GuideModalProps {
  onClose?: () => void;
  open: boolean;
}

function GuideModal({ open, onClose }: GuideModalProps) {
  const sliderRef = useRef<Slider | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const language = useSelector(languageIdSelector);
  const langId = language?.languageId ?? "fr";
  const totalSlides = 3;

  const next = () => {
    if (currentSlide < totalSlides - 1) {
      sliderRef.current?.slickNext();
    } else {
      onClose?.();
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: (index: number) => setCurrentSlide(index),
    appendDots: (dots: React.ReactElement<any>) => (
      <div style={{ maxWidth: "320px", padding: 0, position: "static" }}>
        <ul style={{ margin: "0px" }}>{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "100%",
          background: "#121111",
          opacity: "20%",
        }}
      ></div>
    ),
  };

  return (
    <div className="overflow-hidden guide-slider">
      <Slider ref={sliderRef} {...settings}>
        <div>
          <div className="flex sm:flex-row flex-col items-center gap-6">
            <div>
              <img src={GuideImgOne} alt="guide-img" width={302} height={302} />
            </div>
            <div className="text-center max-w-[246px]">
              <Paragraph text20 className="font-medium mb-2.5 leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step1_title",
                  languageCode: langId,
                }) || "ArtGapi offers a platform for you to sell your artwork."}
              </Paragraph>
              <Paragraph text20 className="!text-[#737373] !leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step1_description",
                  languageCode: langId,
                }) ||
                  "Your Ads post will look like this and Ads post is available in image & video format"}
              </Paragraph>
            </div>
          </div>
        </div>
        <div>
          <div className="flex sm:flex-row flex-col items-center gap-6">
            <div>
              <img src={GuideImgTwo} alt="guide-img" width={302} height={302} />
            </div>
            <div className="text-center max-w-[246px]">
              <Paragraph text20 className="font-medium mb-2.5 leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step2_title",
                  languageCode: langId,
                }) ||
                  "Provide the essential details of your artwork to help us showcase it."}
              </Paragraph>
              <Paragraph text20 className="!text-[#737373] !leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step2_description",
                  languageCode: langId,
                }) ||
                  "Share essential details to enhance its presentation and engage your audience with it."}
              </Paragraph>
            </div>
          </div>
        </div>
        <div>
          <div className="flex sm:flex-row flex-col items-center gap-6">
            <div>
              <img
                src={GuideImgThree}
                alt="guide-img"
                width={302}
                height={302}
              />
            </div>
            <div className="text-center max-w-[246px]">
              <Paragraph text20 className="font-medium mb-2.5 leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step3_title",
                  languageCode: langId,
                }) || "Pay through your stripe account"}
              </Paragraph>
              <Paragraph text20 className="!text-[#737373] !leading-6">
                {LanguageTranslation({
                  labelName: "web_guide_step3_description",
                  languageCode: langId,
                }) ||
                  "Easily complete your purchase: Pay securely and swiftly through your Stripe account"}
              </Paragraph>
            </div>
          </div>
        </div>
      </Slider>

      <div className="flex items-center justify-between gap-3 mt-5">
        <Paragraph
          onClick={onClose}
          text18
          className="font-semibold cursor-pointer"
        >
          {LanguageTranslation({
            labelName: "web_skip",
            languageCode: langId,
          }) || "Skip"}
        </Paragraph>
        <Button primary onClick={next}>
          {currentSlide === totalSlides - 1
            ? LanguageTranslation({
                labelName: "web_done",
                languageCode: langId,
              }) || "Done"
            : LanguageTranslation({
                labelName: "web_next",
                languageCode: langId,
              }) || "Next"}
        </Button>
      </div>
    </div>
  );
}

export default GuideModal;
